import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import styles from '../List/List.module.scss';
import { updateStartsWith } from '../../../Filter/filterActions';

import AZListItem from './AZListItem';
import { RootState } from 'MyTypes';
import { startsWithSelector } from '../../../Filter/filterSelectors';
import { isSearchResultListSelector } from '../../listSelectors';

function getLetters(firstLetter: string, lastLetter: string) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    return alphabet.slice(
        alphabet.indexOf(firstLetter),
        alphabet.indexOf(lastLetter) + 1,
    );
}

const mapStateToProps = (state: RootState) => ({
    activeLetter: startsWithSelector(state),
    isSearchResults: isSearchResultListSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            handleUpdateStartsWith: updateStartsWith,
        },
        dispatch,
    );

type Props = ReturnType<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps>;

const AZList: React.FC<Props> = ({
    handleUpdateStartsWith,
    activeLetter,
    isSearchResults,
}) => {
    if (isSearchResults) {
        return null;
    }

    const azList = getLetters('A', 'Z');

    return (
        <div className={styles.azContainer}>
            {azList.map(label => {
                return (
                    <AZListItem
                        key={label}
                        activeLetter={activeLetter}
                        label={label}
                        handleClick={handleUpdateStartsWith}
                    />
                );
            })}
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AZList);
